// src/api/chatApi.js
import { apiClient, getAuthHeader } from "./apiConfig";

// Helper to read current user from localStorage
const getUser = () => {
  try {
    const u = JSON.parse(localStorage.getItem("user"));
    return u || {};
  } catch {
    return {};
  }
};

// Rooms
export const fetchMyRooms = async () => {
  const { id: user_id } = getUser();
  const res = await apiClient.get(`/chat/my-rooms`, {
    ...getAuthHeader(),
    params: { user_id }, // <-- pass user_id as query param
  });
  return res.data;
};

export const createRoom = async (payload) => {
  // payload: { is_group: 0|1, name?: string, participant_ids: number[] }
  const { id: created_by } = getUser();
  const res = await apiClient.post(
    `/chat/rooms`,
    { ...payload, created_by }, // <-- include creator id
    getAuthHeader()
  );
  return res.data;
};

// Messages
export const fetchMessages = async (roomId, params = {}) => {
  // params: { limit?: number, beforeId?: number }
  const { id: reader_id } = getUser();
  const res = await apiClient.get(`/chat/rooms/${roomId}/messages`, {
    ...getAuthHeader(),
    params: { reader_id, ...params }, // <-- include reader_id to mark reads
  });
  return res.data;
};

export const sendTextMessage = async (roomId, content) => {
  const { id: sender_id } = getUser();

  const form = new FormData();
  form.append("sender_id", sender_id);  // <-- include sender_id
  form.append("type", "text");
  form.append("content", content);

  const res = await apiClient.post(`/chat/rooms/${roomId}/message`, form, {
    ...getAuthHeader(),
    headers: {
      ...getAuthHeader().headers,
      "Content-Type": "multipart/form-data",
    },
  });
  return res.data;
};

export const sendFilesMessage = async (roomId, files, caption = "") => {
  const { id: sender_id } = getUser();

  const form = new FormData();
  form.append("sender_id", sender_id);  // <-- include sender_id
  form.append("type", "file");
  if (caption) form.append("content", caption);
  files.forEach((f) => form.append("files[]", f));

  const res = await apiClient.post(`/chat/rooms/${roomId}/message`, form, {
    ...getAuthHeader(),
    headers: {
      ...getAuthHeader().headers,
      "Content-Type": "multipart/form-data",
    },
  });
  return res.data;
};

// Participants (for group rooms)
export const addParticipants = async (roomId, userIds = []) => {
  const res = await apiClient.post(
    `/chat/rooms/${roomId}/participants`,
    { user_ids: userIds },
    getAuthHeader()
  );
  return res.data;
};

// Helper: build download URL for an attachment
export const downloadFileUrl = (attachmentId) =>
  `${apiClient.defaults.baseURL?.replace(/\/$/, "")}/chat/files/${attachmentId}`;
